import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Ticket } from '../shared/interface/ticket';
import { UserService } from '../shared/services/user/user.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SupportComponent implements OnInit {
  userId: string = "";
  user: any;
  dataSource: Ticket[];
  constructor(public dialog: MatDialog, private userService: UserService) { }

  ngOnInit() {
    this.dataSource = [
      { id: '132468', date: '12/12/17', type: 'Device', title: 'Xovis is not working', status: 'Pending' },
      { id: '132468', date: '12/12/17', type: 'Device', title: 'Xovis is not working', status: 'Open' },
      { id: '132468', date: '12/12/17', type: 'Device', title: 'Xovis is not working', status: 'Pending' },
      { id: '132468', date: '12/12/17', type: 'Device', title: 'Xovis is not working', status: 'Closed' },
    ];
    this.user = this.userService.getLoggedInUser();
    this.userId = this.user._id;
  }

  openIssueDialog() {
    this.dialog.open(IssueDialog, {
      height: 'auto',
      width: '400px',
      panelClass: 'full-modal'
    });
  }
}


@Component({
  selector: 'issue-dialog',
  templateUrl: 'issue.dialog.html'
})
export class IssueDialog {

  constructor() {

  }
}


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/support/support.component.ts